module.exports = __webpack_public_path__ + "media/1_9.6a420bf3.wav";